<template>
  <div name="online-form" v-form v-loading="loading">
    <eco-runtime-template
      v-if="!loadedFail"
      ref="onlineForm"
      :data="data"
      :permission="permission"
      :isView="isView"
      :isPrint="isPrint"
      :isSum="isSum"
      :processUrl="processUrl"
      :model="model"
      :isShowDiff="isShowDiff"
      :diffData="diffData"
    >
    </eco-runtime-template>
    <!-- <div
      v-if="!loadedFail && !isHideBtn"
      slot="footer"
      style="text-align: center"
    >


      <fe-submit-button
        v-if="processUrl && isShowProcessBtn"
        :url="processUrl"
        :model="model"
        :request-method="saveMethod"
        :isdepart="depart ? data : ''"
        :isConsPro="isConsPro"
        :is-submit="isSubmit"
        :fromContract="fromContract"
        scope-name="custom-form"
        @before-save-data="beforeSaveData"
        @after-save-data="afterSaveData"
        >{{ $t("eip.common.saveAndProcess") }}
      </fe-submit-button>
      <fe-submit-button
        v-if="processUrl && isShowEditProcessBtn"
        :url="processUrl"
        :model="model"
        :request-method="saveMethod"
        :isdepart="depart ? data : ''"
        :isConsPro="isConsPro"
        :is-submit="isSubmit"
        :fromContract="fromContract"
        scope-name="custom-form"
        @before-save-data="beforeSaveData"
        @after-save-data="afterSaveData"
        >{{ $t("eip.common.editAndProcess") }}
      </fe-submit-button>
      <fe-submit-button
        v-if="!processUrl || (!isShowProcessBtn && !isShowEditProcessBtn)"
        :url="url"
        :model="model"
        :request-method="saveMethod"
        :isdepart="depart ? data : ''"
        :isConsPro="isConsPro"
        :fromContract="fromContract"
        :is-submit="isSubmit"
        scope-name="custom-form"
        @before-save-data="beforeSaveData"
        @after-save-data="afterSaveData"
        >{{ $t("eip.common.save") }}
      </fe-submit-button>
      <fe-submit-button
        v-if="draftUrl && !isEdit"
        :type="'success'"
        :url="draftUrl"
        :model="model"
        :request-method="saveMethod"
        :isdepart="depart ? data : ''"
        :isConsPro="isConsPro"
        scope-name="custom-form"
        >{{ $t("eip.common.draft") }}
      </fe-submit-button>
      <el-button v-if="draftUrl && !isEdit" type="info" @click="clearDialog">
        {{ $t("eip.common.clear") }}
      </el-button>
      <el-button @click="beforeCloseDialog"
        >{{ $t("eip.common.cancel") }}
      </el-button>
    </div> -->

    <div class="loaded-fail__div" v-if="loadedFail">表单加载失败...</div>
  </div>
</template>
<script>
import EipInput from '@/components/eipControl/EipInput.vue'
import EipCheckbox from '@/components/eipControl/EipCheckbox.vue'
import EipSelect from '@/components/eipControl/EipSelect.vue'
import EipRadio from '@/components/eipControl/EipRadio.vue'
import EipUserSelector from '@/components/eipControl/selector/EipUserSelector.vue'
import EipDemensionSelector from '@/components/eipControl/selector/EipDemensionSelector.vue'
import EipJobSelector from '@/components/eipControl/selector/EipJobSelector.vue'
import EipOrgSelector from '@/components/eipControl/selector/EipOrgSelector.vue'
import EipPostSelector from '@/components/eipControl/selector/EipPostSelector.vue'
import EipRoleSelector from '@/components/eipControl/selector/EipRoleSelector.vue'
import EipTextarea from '@/components/eipControl/EipTextarea.vue'
import EipFont from '@/components/eipControl/EipFont.vue'
import EipDialog from '@/components/eipControl/EipDialog.vue'
import EipAutocomplete from '@/components/eipControl/EipAutocomplete.vue'
import EipCascader from '@/components/eipControl/EipCascader.vue'
import EipTreeselect from '@/components/eipControl/EipTreeselect.vue'
import EipButton from '@/components/eipControl/EipButton.vue'
import EipDate from '@/components/eipControl/EipDate.vue'
import EipImg from '@/components/eipControl/EipImg.vue'
import EipViewer from '@/components/eipControl/EipViewer.vue'
import EipSwitch from '@/components/eipControl/EipSwitch.vue'
import EipMap from '@/components/eipControl/EipMap.vue'
import EcoFile from '@/components/control/FeFile.vue'
import VRuntimeTemplate from 'v-runtime-template'
import EcoGangedSelect from '@/components/control/FeGangedSelect.vue'
import EipRelFlow from '@/components/eipControl/EipRelFlow.vue'
import EipSubDialog from '@/components/eipControl/EipSubDialog.vue'
import EcoLabel from '@/components/control/FeLabel.vue'
import EcoDigital from '@/components/control/FeDigital.vue'
import EcoCurrency from '@/components/control/FeCurrency.vue'
import EipRealtimeInput from '@/components/eipControl/EipRealtimeInput.vue'
import EipRealtimeTextarea from '@/components/eipControl/EipRealtimeTextarea.vue'
import EipStep from '@/components/eipControl/EipStep.vue'
import EcoInputAutocomplete from '@/components/control/FeInputAutocomplete.vue'
import EcoTreeselect from '@/components/control/FeTreeselect.vue'
import EcoCascader from '@/components/control/FeCascader.vue'
import EcoTree from '@/components/control/FeTree.vue'

import EipAttachment from '@/components/eipControl/EipAttachment.vue'
import EipDic from '@/components/eipControl/EipDic.vue'
import EipPaginationLayout from '@/components/eipControl/EipPaginationLayout.vue'
import EipPagination from '@/components/eipControl/EipPagination.vue'
import EipCollapse from '@/components/eipControl/EipCollapse.vue'
import EipPaginationSteps from '@/components/eipControl/EipPaginationSteps.vue'
import EipDataView from '@/components/eipControl/EipDataView.vue'
// import ContractPrint from "@/components/contractPrint/index.vue";
// import NewsPreview from "@/components/common/newsPreview.vue";
import Bus from '@/myServer.js'
import Vue from 'vue'
import utils from '../../../eco-ui-util'

export default {
  name: 'online-form',
  props: [
    'html',
    'data',
    'permission',
    'isView',
    'isPrint',
    'isEdit',
    'model',
    'title',
    'url',
    'processUrl',
    'processStatus',
    'draftUrl',
    'saveMethod',
    'depart',
    'isHideBtn',
    'isConsPro',
    'isShowProcessBtn',
    'isShowEditProcessBtn',
    'isSubmit',
    'isSum',
    'isPreview',
    'previewType',
    'fromContract',
    'diffData',
    'isShowDiff',
    'viewType',
    'isNotParent'
  ],
  data() {
    return {
      loading: false,
      loadedFail: false, //表单加载html是否失败
      subBackfill: new Map()
    }
  },
  created() {
    this.init()
  },
  updated() {
    this.$root.$validator.errors.clear('custom-form')
    this.$validator.errors.clear('custom-form')
    const list = document.querySelectorAll('div')
    const list1 = document.querySelectorAll('input')
    if (list && list.length > 0) {
      list.forEach((ele) => {
        const a = ele.getAttribute('aria-invalid')
        if (a === 'true') {
          ele.setAttribute('aria-invalid', 'false')
        }
      })
    }
    if (list1 && list1.length > 0) {
      list1.forEach((ele) => {
        const a = ele.getAttribute('aria-invalid')
        if (a === 'true') {
          ele.setAttribute('aria-invalid', 'false')
        }
      })
    }
  },
  watch: {
    html: function (newVal) {
      if (newVal) {
        this.init()
      }
    },
    isShowProcessBtn: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          //调用租户配置，查看当前是否开启流程
          this.getProcessBtn()
        }
      }
    },
    isShowEditProcessBtn: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          //调用租户配置，查看当前是否开启流程
          this.getEditProcessBtn()
        }
      }
    },
    'data.Journal': {
      deep: true,
      handler(newVal, oldVal) {
        this.getTime()
        // this.$parent.$emit("dialogclose", this.data);
      }
    }
  },
  methods: {
    previewClick() {},
    //调用租户配置，查看当前是否开启流程
    getProcessBtn() {
      if (this.processUrl) {
        const index = this.processUrl.lastIndexOf('/')
        let str = ''
        const a = this.processUrl.split('/process/')
        switch (a[a.length - 1]) {
          case 'borrow/qualification_certificate':
            str = 'borrow_qualification_certificate'
            break
          case 'postpone/qualification_certificate':
            str = 'postpone_qualification_certifica'
            break
          case 'returns/qualification_certificate':
            str = 'returns_qualification_certificat'
            break
          case 'borrow/certificate':
            str = 'borrow_certificate'
            break
          case 'postpone/certificate':
            str = 'postpone_certificate'
            break
          case 'returns/certificate':
            str = 'returns_certificate'
            break
          default:
            str = this.processUrl.substring(index + 1, this.processUrl.length)
            break
        }
        this.$http.get('${portal}/system/flow_config/getByKey/' + str).then((res) => {
          if (res && res.data) {
            if (this.model && this.model.id) {
              if (
                str != 'law_contract_seal_filing' &&
                str != 'pro_personnel_transfer_departure' &&
                str != 'design_pro_personnel_transfer_departure' &&
                str != 'pro_data_archive' &&
                str != 'pro_data_archive_design'
              ) {
                this.isShowProcessBtn = false
              } else {
                this.isShowProcessBtn = res.data.status === 1
              }
            } else {
              this.isShowProcessBtn = res.data.status === 1
            }
          } else {
            this.isShowProcessBtn = false
          }
          this.$emit('isOpen', this.isShowProcessBtn)
        })
      }
    },
    getEditProcessBtn() {
      if (this.processUrl) {
        const index = this.processUrl.lastIndexOf('/')
        let str = ''
        const a = this.processUrl.split('/process/')
        switch (a[a.length - 1]) {
          case 'borrow/qualification_certificate':
            str = 'borrow_qualification_certificate'
            break
          case 'postpone/qualification_certificate':
            str = 'postpone_qualification_certifica'
            break
          case 'returns/qualification_certificate':
            str = 'returns_qualification_certificat'
            break
          case 'borrow/certificate':
            str = 'borrow_certificate'
            break
          case 'postpone/certificate':
            str = 'postpone_certificate'
            break
          case 'returns/certificate':
            str = 'returns_certificate'
            break
          default:
            str = this.processUrl.substring(index + 1, this.processUrl.length)
            break
        }
        this.$http.get('${portal}/system/flow_config/getByKey/' + str).then((res) => {
          let temp = false
          if (res && res.data) {
            temp = res.data.status === 1
          }
          this.$emit('isOpenEdit', temp)
        })
      }
    },
    getTime() {
      if (this.data && this.data.Journal) {
        let res = this.data.Journal
        if (res.begin_date != '' && res.end_date != '') {
          let start = res.begin_date
          let end = res.end_date
          let time = parseFloat((Date.parse(end) - Date.parse(start)) / (1000 * 60 * 60))
          var str = time.toString().split('.')
          this.data.Journal.time = str[0] + '.' + str[1].substring(0, 1)
        }
      }
    },
    async beforeSaveData() {
      await this.$emit('before-save-data')
    },
    afterSaveData() {
      this.loading = true
      setTimeout(() => {
        this.beforeCloseDialog()
        if (this.isNotParent) {
          this.$emit('load')
        } else {
          this.$parent.$emit('load')
        }
        this.loading = false
      }, 500)
    },
    beforeCloseDialog() {
      if (this.isNotParent) {
        this.$emit('dialogclose', this.data)
      } else {
        this.$parent.$emit('dialogclose', this.data)
      }
    },
    clearDialog() {
      this.$http.remove(this.draftUrl).then(
        (resp) => {
          let response = resp.data
          if (response) {
            this.$message.success('清空草稿成功')
          }
        },
        (error) => {
          reject(error)
          this.$message.error('清空草稿失败')
        }
      )
      this.$parent.$emit('clear', this.data)
    },
    init() {
      let that = this
      Vue.component('eco-runtime-template', {
        props: [
          'html',
          'data',
          'permission',
          'isView',
          'isPrint',
          'model',
          'title',
          'url',
          'processUrl',
          'processStatus',
          'draftUrl',
          'saveMethod',
          'depart',
          'isHideBtn',
          'isSum',
          'diffData',
          'isShowDiff',
          'isShowProcessBtn',
          'isShowEditProcessBtn'
          // "model",
        ],
        template: this.html,
        data() {
          return {
            transitionIndex: -1,
            curTabIndex: 'tabe_check_0',
            errMesg: ''
          }
        },
        watch: {
          data: {
            handler: function (newVal) {
              // console.log(newVal);
              if (newVal) {
                this.$root.$validator.errors.clear('custom-form')
                this.$validator.errors.clear('custom-form')
                const list = document.querySelectorAll('div')
                const list1 = document.querySelectorAll('input')
                if (list && list.length > 0) {
                  list.forEach((ele) => {
                    const a = ele.getAttribute('aria-invalid')
                    if (a === 'true') {
                      ele.setAttribute('aria-invalid', 'false')
                    }
                  })
                }
                if (list1 && list1.length > 0) {
                  list1.forEach((ele) => {
                    const a = ele.getAttribute('aria-invalid')
                    if (a === 'true') {
                      ele.setAttribute('aria-invalid', 'false')
                    }
                  })
                }
              }
            },
            deep: true,
            immediate: true
          },
          model: {
            deep: true,
            handler(newVal, oldVal) {
              if (newVal != oldVal && newVal != '' && newVal != undefined && this.isSum == true) {
                this.getSum()
              }
              if (this.processUrl) {
                const index = this.processUrl.lastIndexOf('/')
                const str = this.processUrl.substring(index + 1, this.processUrl.length)
                if (newVal && newVal.id && this.isShowProcessBtn) {
                  if (
                    str != 'law_contract_seal_filing' &&
                    str != 'pro_personnel_transfer_departure' &&
                    str != 'design_pro_personnel_transfer_departure' &&
                    str != 'pro_data_archive' &&
                    str != 'pro_data_archive_design'
                  ) {
                    this.$parent.$emit('isOpen', false)
                  } else {
                    this.$parent.$emit('isOpen', true)
                  }
                }
              } else {
                if (newVal && newVal.id) {
                  this.$parent.$emit('isOpen', false)
                }
              }
              Bus.$emit('BusPrintModel', newVal)
            }
          }
        },
        mounted() {
          // 如果当前表单的element为Comment说明表单加载失败了。
          // console.log(this.$el, this.$el.constructor, 22)
          // if (this.$el && this.$el.constructor == Comment) {
          //   this.$parent.loadedFail = true;
          // }
          //  // this.$validator = this.$root.$validator;
          if (this.permission && this.permission.table) {
            for (let subTableName in this.permission.table) {
              if (this.permission.table[subTableName].required) {
                this.addSubTableByName(subTableName)
              }
            }
          }
          if (this.isPrint) {
            this.printDetail()
          }
          Bus.$on('pushPrintModel', (data) => {
            this.model = data
          })
          // 判断diff
          // if (this.isShowDiff) {
          //   const afterFormList = document.querySelectorAll(
          //     ".afterForm .el-form-item__content>.inputs"
          //   );
          //   afterFormList.forEach(item => {
          //     let aa = item.getAttribute("model-name");
          //     // 普通不包含子表对比
          //     if (aa.indexOf("payment_rete") > -1) {
          //       let bb = item.querySelector("input") || item.querySelector("span.field-tail") || item.querySelector("span.el-select__tags-text")
          //       bb.style.color = "red";
          //     }
          //   });
          // }
        },
        updated() {
          // document.getElementById("fii_invoice_amount").innerText = "123";
          this.$root.$validator.errors.clear('custom-form')
          this.$validator.errors.clear('custom-form')
          const list = document.querySelectorAll('div')
          const list1 = document.querySelectorAll('input')
          if (list && list.length > 0) {
            list.forEach((ele) => {
              const a = ele.getAttribute('aria-invalid')
              if (a === 'true') {
                ele.setAttribute('aria-invalid', 'false')
              }
            })
          }
          if (list1 && list1.length > 0) {
            list1.forEach((ele) => {
              const a = ele.getAttribute('aria-invalid')
              if (a === 'true') {
                ele.setAttribute('aria-invalid', 'false')
              }
            })
          }
        },
        //改v-runtime-template.es.js的源码，或者改v-runtime-template的版本改成1.5.2
        methods: {
          getSum() {
            let sumValue = {}
            let subName = ''
            let sumName = []
            Object.keys(this.model).forEach((item) => {
              if (item.substring(0, 3) == 'sub') {
                subName = item
              }
            })
            if (subName != '') {
              if (this.model[subName]) {
                this.model[subName].forEach((item) => {
                  Object.keys(item).forEach((items) => {
                    if (typeof item[items] == 'number' && items.substring(0, 1) != 'F') {
                      sumName.push(items)
                      if (sumValue[items]) {
                        sumValue[items] += item[items]
                      } else {
                        sumValue[items] = 0
                        sumValue[items] += item[items]
                      }
                    }
                  })
                })
              }
              // subName.forEach((item) => {});
              document.getElementById('sum').innerText = '合计'
              sumName.forEach((item) => {
                if (document.getElementById(item) != null) {
                  document.getElementById(item).innerText = utils.dataTransform(sumValue[item].toString())
                }
              })
            }
          },
          printDetail() {
            let a = document.getElementsByName('online-form')[0].innerHTML
            window.print()
            if (this.data) {
              this.$router.go(-1)
            }
            setTimeout(function () {
              location.reload()
            }, 200)
          },
          async leaveTabVerify(activeName, oldActiveName) {
            let erritems = []
            let formElementAry = document.getElementsByName('online-form')
            let frmInst = formElementAry[0].__vue__
            let childrens = frmInst.$refs.onlineForm.$children[0].$refs
            let result = await frmInst.$root.$validator.validateAll('custom-form')
            if (!result) {
              let curEl = childrens[oldActiveName].$el
              this.$validator.errors.items.forEach((item) => {
                if (curEl.contains(document.getElementsByName(item.field)[0])) {
                  erritems.push(item)
                }
              })
            }
            //拼接提示消息
            let msg = ''
            for (let item of erritems) {
              let fieldLabel = ''
              if (item.field) {
                fieldLabel = item.field
              }
              if (item.field && item.field.indexOf('-') != -1) {
                fieldLabel = item.field.substr(item.field.indexOf('-') + 1)
              }
              msg += fieldLabel + ' ' + item.msg + '<br/>'
            }
            if (msg) {
              this.$notify.error({
                title: this.$t('common.errTip'),
                dangerouslyUseHTMLString: true,
                message: msg
              })
              reject()
            }
          },
          //子表上移
          up(index, data) {
            if (index === 0) {
              this.$message({
                message: '已经是列表中第一位',
                type: 'warning'
              })
            } else {
              let temp = data[index - 1]
              Vue.set(data, index - 1, data[index])
              Vue.set(data, index, temp)
            }
          },
          //子表默认值回填
          addSubTab(subTabPath) {
            let pathArr = subTabPath.split('.')
            if (pathArr.length < 3) {
              this.$message({
                message: '子表路径有误',
                type: 'warning'
              })
            } else {
              let subTabName = pathArr[2].replace('sub_', '')
              let subInitData = this.data[pathArr[1]].initData[subTabName] || {}
              //判断当前子表是否存有回显值
              if (this.$parent.subBackfill && this.$parent.subBackfill.has(subTabPath)) {
                //this.data[pathArr[1]][pathArr[2]].push(this.$parent.subBackfill.get(subTabPath));
                subInitData = this.$parent.subBackfill.get(subTabPath)
              }
              //把数组里面的值为 null 转换为空字符串
              let str = JSON.stringify(subInitData).replace(/null/g, '""')
              let subData = JSON.parse(str)
              for (var key in subData) {
                if (key.indexOf('sub_') == 0 && !subData[key]) {
                  subData[key] = []
                }
              }
              let sum = 0
              if (this.data.marketing_pro && this.data.marketing_pro.sub_segmentation && this.data.marketing_pro.sub_segmentation.length > 0) {
                this.data.marketing_pro.sub_segmentation.forEach((ele) => {
                  sum = Number(ele.segmentation_ratio) + sum
                })
                subData.segmentation_ratio = String(1 - sum)
              }
              this.data[pathArr[1]][pathArr[2]].push(subData)
              this.$root.$validator.errors.clear('custom-form')
              const list = document.querySelectorAll('div')
              const list1 = document.querySelectorAll('input')
              if (list && list.length > 0) {
                list.forEach((ele) => {
                  const a = ele.getAttribute('aria-invalid')
                  if (a === 'true') {
                    ele.setAttribute('aria-invalid', 'false')
                  }
                })
              }
              if (list1 && list1.length > 0) {
                list1.forEach((ele) => {
                  const a = ele.getAttribute('aria-invalid')
                  if (a === 'true') {
                    ele.setAttribute('aria-invalid', 'false')
                  }
                })
              }
              // this.permission.table[subTabName].required = "false";
            }
          },
          //孙表默认值回填
          addSunTab(subTabPath, subIndex) {
            let pathArr = subTabPath.split('.')
            if (pathArr.length < 4) {
              this.$message({
                message: '孙表路径有误',
                type: 'warning'
              })
            } else {
              let subTabName = pathArr[2].replace('sub_', '')
              let sunTabName = pathArr[3].replace('sub_', '')
              let subInitData = this.data[pathArr[1]].initData[subTabName].initData[sunTabName] || {}
              //判断当前子表是否存有回显值
              if (this.$parent.subBackfill && this.$parent.subBackfill.has(subTabPath)) {
                //this.data[pathArr[1]][pathArr[2]].push(this.$parent.subBackfill.get(subTabPath));
                subInitData = this.$parent.subBackfill.get(subTabPath)
              }
              //把数组里面的值为 null 转换为空字符串
              let str = JSON.stringify(subInitData).replace(/null/g, '""')
              this.data[pathArr[1]][pathArr[2]][subIndex][pathArr[3]].push(JSON.parse(str))
              this.$root.$validator.errors.clear('custom-form')
              const list = document.querySelectorAll('div')
              const list1 = document.querySelectorAll('input')
              if (list && list.length > 0) {
                list.forEach((ele) => {
                  const a = ele.getAttribute('aria-invalid')
                  if (a === 'true') {
                    ele.setAttribute('aria-invalid', 'false')
                  }
                })
              }
              if (list1 && list1.length > 0) {
                list1.forEach((ele) => {
                  const a = ele.getAttribute('aria-invalid')
                  if (a === 'true') {
                    ele.setAttribute('aria-invalid', 'false')
                  }
                })
              }

              // this.permission.table[sunTabName].required = "false";
            }
          },
          addSubTableByName(subTableName) {
            for (let boAlias in this.data) {
              let subInitData = this.data[boAlias].initData[subTableName] || {}
              if (this.data[boAlias]['sub_' + subTableName].length < 1) {
                this.data[boAlias]['sub_' + subTableName].push(JSON.parse(JSON.stringify(subInitData)))
              }
            }
            this.$root.$validator.errors.clear('custom-form')
            const list = document.querySelectorAll('div')
            const list1 = document.querySelectorAll('input')
            if (list && list.length > 0) {
              list.forEach((ele) => {
                const a = ele.getAttribute('aria-invalid')
                if (a === 'true') {
                  ele.setAttribute('aria-invalid', 'false')
                }
              })
            }
            if (list1 && list1.length > 0) {
              list1.forEach((ele) => {
                const a = ele.getAttribute('aria-invalid')
                if (a === 'true') {
                  ele.setAttribute('aria-invalid', 'false')
                }
              })
            }
          },
          deleteRow(subTablePath, item) {
            let pathArr = subTablePath.split('.')
            if (pathArr.length < 2) {
              this.$message({
                message: '子表路径有误',
                type: 'warning'
              })
            } else {
              let subTabName = pathArr[1].replace('sub_', '')
              if (
                this.data[pathArr[0]][pathArr[1]].length == 1 &&
                (this.permission.table[subTabName].required == true || this.permission.table[subTabName].required == 'true')
              ) {
                this.$message.info({
                  message: '子表必填一条记录',
                  type: 'warning'
                })
                return
              }
              this.data[pathArr[0]][pathArr[1]].remove(item)
            }
            this.$root.$validator.errors.clear('custom-form')
            const list = document.querySelectorAll('div')
            const list1 = document.querySelectorAll('input')
            if (list && list.length > 0) {
              list.forEach((ele) => {
                const a = ele.getAttribute('aria-invalid')
                if (a === 'true') {
                  ele.setAttribute('aria-invalid', 'false')
                }
              })
            }
            if (list1 && list1.length > 0) {
              list1.forEach((ele) => {
                const a = ele.getAttribute('aria-invalid')
                if (a === 'true') {
                  ele.setAttribute('aria-invalid', 'false')
                }
              })
            }
          },
          deleteSunRow(subTablePath, item, subIndex) {
            let pathArr = subTablePath.split('.')
            if (pathArr.length < 3) {
              this.$message({
                message: '孙表路径有误',
                type: 'warning'
              })
            } else {
              let subTabName = pathArr[1].replace('sub_', '')
              let sunTabName = pathArr[2].replace('sub_', '')
              if (
                this.data[pathArr[0]][pathArr[1]][subIndex][pathArr[2]].length == 1 &&
                (this.permission.table[sunTabName].required == true || this.permission.table[subTabName].required == 'true')
              ) {
                this.$message({
                  message: '孙表必填一条记录',
                  type: 'warning'
                })
                return
              }
              this.data[pathArr[0]][pathArr[1]][subIndex][pathArr[2]].remove(item)
            }
            this.$root.$validator.errors.clear('custom-form')
            const list = document.querySelectorAll('div')
            const list1 = document.querySelectorAll('input')
            if (list && list.length > 0) {
              list.forEach((ele) => {
                const a = ele.getAttribute('aria-invalid')
                if (a === 'true') {
                  ele.setAttribute('aria-invalid', 'false')
                }
              })
            }
            if (list1 && list1.length > 0) {
              list1.forEach((ele) => {
                const a = ele.getAttribute('aria-invalid')
                if (a === 'true') {
                  ele.setAttribute('aria-invalid', 'false')
                }
              })
            }
          },
          //子表下移
          down(index, data) {
            if (index === data.length - 1) {
              this.$message({
                message: '已经是列表中最后一位',
                type: 'warning'
              })
            } else {
              this.isTransition = true
              let i = data[index + 1]
              Vue.set(data, index + 1, data[index])
              Vue.set(data, index, i)
            }
          },
          //点击分页校验按钮触发事件
          nextStepClick(isCheck, index, way) {
            let childrens = this.$refs.onlineForm.$children[0].$refs
            let nextIndex = way == 'back' ? index - 1 : index + 1
            //进入下一个页签并且需要校验当前页签。则进行校验
            if (way == 'next' && isCheck == 'y') {
              this.$validator.validateAll('custom-form').then((result) => {
                let curTabHasError = false
                if (!result) {
                  let curEl = childrens['next_step_check_' + index].$el
                  this.$validator.errors.items.forEach((item) => {
                    if (curEl.contains(document.getElementsByName(item.field)[0])) {
                      curTabHasError = true
                      return
                    }
                  })
                }
                if (result || !curTabHasError) {
                  childrens.el_table_check.currentName = nextIndex + ''
                  var childrensArray = Object.getOwnPropertyNames(childrens)
                  childrensArray.remove('collapse')
                  if (index == childrensArray.length - 3 && way == 'next') {
                    this.$root.$emit('startFlowBtnChange', true)
                  }
                }
              })
            } else {
              childrens.el_table_check.currentName = nextIndex + ''
              var childrensArray = Object.getOwnPropertyNames(childrens)
              childrensArray.remove('collapse')
              if (index == childrensArray.length - 3 && way == 'next') {
                this.$root.$emit('startFlowBtnChange', true)
              }
            }
          }
        },
        components: {
          // NewsPreview,
          EipPagination,
          EipPaginationLayout,
          EipInput,
          EipCheckbox,
          EipSelect,
          EipUserSelector,
          EipDemensionSelector,
          EipJobSelector,
          EipOrgSelector,
          EipPostSelector,
          EipRoleSelector,
          EipRadio,
          EipTextarea,
          EipFont,
          EipDialog,
          EipButton,
          EipDate,
          EipImg,
          EipViewer,
          EipSwitch,
          EcoFile,
          VRuntimeTemplate,
          EcoGangedSelect,
          EipRelFlow,
          EipSubDialog,
          EcoLabel,
          EcoDigital,
          EcoCurrency,
          EipRealtimeInput,
          EipRealtimeTextarea,
          EipStep,
          EcoInputAutocomplete,
          EcoTreeselect,
          EcoCascader,
          EcoTree,
          EipAttachment,
          EipDic,
          EipAutocomplete,
          EipCascader,
          EipTreeselect,
          EipCollapse,
          EipPaginationSteps,
          EipMap,
          // ContractPrint,
          EipDataView
        }
      })
    }
  }
}
</script>
<style>
.el-row--flex.is-align-middle {
  text-align: center;
}
.transition {
  outline: 1px dotted #85a5ff;
  outline-width: 2px;
  outline-offset: -1px;
}

.el-tabs--border-card {
  border: 1px solid #ebeef5;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.tabcheck_btn {
  text-align: right;
  padding-top: 20px;
}

.loaded-fail__div {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #f56c6c;
}
</style>
